import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCar7Ev: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCar7Ev"><Path d="M19.75 17.5H22.5V10.5L18 9.25L15 4.5H8.5V10.5H1.5V17.5H4.25" stroke="currentColor"/><Circle cx="7" cy="17" r="2.5" stroke="currentColor"/><Circle cx="17" cy="17" r="2.5" stroke="currentColor"/><Path d="M9.75 17.5H14.25" stroke="currentColor"/><Path d="M15.75 10.25H13.5972L13.9445 8L10.75 11.75H12.9028L12.5556 14L15.75 10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCar7Ev;
